"use strict";
/*
 * This file is part of the IVMS Online.
 *
 * @copyright 2022 - 2023, 2025 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselActions = void 0;
const material_1 = require("@mui/material");
const react_1 = require("react");
const React = require("react");
const api_1 = require("../../api");
const VesselActions = ({ vessel }) => {
    const [pending, setPending] = (0, react_1.useState)([]);
    const trigger = (vesselId, sensorId, value) => {
        const triggerKey = `${vesselId}:${sensorId}`;
        setPending(pending.concat([triggerKey]));
        api_1.api.graphql({
            query: api_1.triggerVesselMutation,
            variables: {
                vesselId,
                sensorId,
                value,
            }
        }).finally(() => setPending(pending.filter(key => triggerKey !== key)));
    };
    return React.createElement(React.Fragment, null, vessel.actions.map(action => React.createElement(material_1.Button, { key: `${action.sensorId}:${action.value}`, size: "small", onClick: () => trigger(vessel.vesselId, action.sensorId, action.value), disabled: pending.includes(`${vessel.vesselId}:${action.sensorId}`) }, action.label)));
};
exports.VesselActions = VesselActions;
